
export interface Campaign {
	Id: number;
	Enabled: boolean;
	Name: string;
	Url: string;
	StartDateUtc: string;
	EndDateUtc: string;
	DateCreatedUtc: string;
	PersistType: CampaignPersistType;
}

export interface CampaignDisplay extends Campaign {
	Slides: CampaignSlide[];
}

export class CreateCampaignModel {
	Name: string;
	Url: string;
	StartDateUtc: Date;
	EndDateUtc: Date;
	Enabled: boolean;
	PersistType: CampaignPersistType;
}

export class EditCampaignModel extends CreateCampaignModel {
	Id: number;
	constructor(item?: Campaign) {
		super();
		this.Id = item && item.Id;
		this.Enabled = item && item.Enabled;
		this.Name = item && item.Name;
		this.Url = item && item.Url;
		this.StartDateUtc = item && new Date(item.StartDateUtc + 'z');
		this.EndDateUtc = item && new Date(item.EndDateUtc + 'z');
		this.PersistType = item && item.PersistType;
	}
}


export interface CampaignSlide {
	CampaignId: number;
	DocumentId: number;
	ActionName: string;
	ActionPath: string;
	DocumentPublicId: string | null;
	DocumentContentType: string;
	ActionColor: string;
	Timeout: number;
	SoundMuted: boolean;
}

export class CampaignSlideModel {
	CampaignId: number;
	DocumentId: number;
	DocumentPublicId: string;
	DocumentContentType: string;
	ActionName: string;
	ActionPath: string;
	ActionColor: string;
	Timeout: number;
	SoundMuted: boolean;
	constructor(item?: CampaignSlide) {
		this.CampaignId = item && item.CampaignId;
		this.DocumentId = item && item.DocumentId;
		this.DocumentPublicId = item && item.DocumentPublicId;
		this.DocumentContentType = item && item.DocumentContentType;
		this.ActionName = item && item.ActionName;
		this.ActionPath = item && item.ActionPath;
		this.ActionColor = item && item.ActionColor;
		this.Timeout = item && item.Timeout;
		this.SoundMuted = item && item.SoundMuted;
	}
}

export enum CampaignPersistType {
	Always = 0,
	Session = 1,
	Device = 2,
	Lifetime = 3
}



// WEBPACK FOOTER //
// ./src/app/models/inModels/campaign.ts